/* eslint-disable no-unused-vars */
import React from "react";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import LogoHeader from "../common/LogoHeader";

import Signup from "../Signup";
import useUserStore from "../../stores/useUserStores";

const AuthSignup = () => {
  const { islogin } = useUserStore();
  return (
    <>
      {!islogin ? (
        <>
          <LogoHeader />
          <Signup />
        </>
      ) : (
        <Navigate replace to="/" />
      )}
    </>
  );
};

export default AuthSignup;
